import React from 'react'
import { PulseLoader } from 'react-spinners'

function ButtonLoading({color,size}) {
  return (
    <PulseLoader color={color === undefined ? 'white' : color} speedMultiplier='0.5' size={size} />
  )
}

export default ButtonLoading
